<div class="stub">
  {{ 'classrooms.invite.stub.title' | customLocale }}<br>
  {{ 'classrooms.invite.stub.description' | customLocale }}
</div>
